/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payout_FrequencyInputs */

const en_payout_frequency = /** @type {(inputs: Payout_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payout Frequency`)
};

const es_payout_frequency = /** @type {(inputs: Payout_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frecuencia de pago`)
};

const fr_payout_frequency = /** @type {(inputs: Payout_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fréquence des paiements`)
};

const de_payout_frequency = /** @type {(inputs: Payout_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auszahlungshäufigkeit`)
};

const ja_payout_frequency = /** @type {(inputs: Payout_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支払い頻度`)
};

const zh_payout_frequency = /** @type {(inputs: Payout_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提现频率`)
};

const ar_payout_frequency = /** @type {(inputs: Payout_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وتيرة سداد المدفوعات`)
};

const id_payout_frequency = /** @type {(inputs: Payout_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frekuensi Pembayaran`)
};

const it_payout_frequency = /** @type {(inputs: Payout_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequenza dei Pagamenti`)
};

const ru_payout_frequency = /** @type {(inputs: Payout_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Частота выплат`)
};

const pt_payout_frequency = /** @type {(inputs: Payout_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequência de Pagamento`)
};

const ko_payout_frequency = /** @type {(inputs: Payout_FrequencyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`정산 주기`)
};

/**
* | output |
* | --- |
* | "Payout Frequency" |
*
* @param {Payout_FrequencyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const payout_frequency = /** @type {((inputs?: Payout_FrequencyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payout_FrequencyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_payout_frequency(inputs)
	if (locale === "es") return es_payout_frequency(inputs)
	if (locale === "fr") return fr_payout_frequency(inputs)
	if (locale === "de") return de_payout_frequency(inputs)
	if (locale === "ja") return ja_payout_frequency(inputs)
	if (locale === "zh") return zh_payout_frequency(inputs)
	if (locale === "ar") return ar_payout_frequency(inputs)
	if (locale === "id") return id_payout_frequency(inputs)
	if (locale === "it") return it_payout_frequency(inputs)
	if (locale === "ru") return ru_payout_frequency(inputs)
	if (locale === "pt") return pt_payout_frequency(inputs)
	return ko_payout_frequency(inputs)
});